module.exports = __webpack_public_path__ + "media/images/logos/Monash-University-d20bf3f3d4b9cae3490c9a66e87e5ada.svg";